
import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';

import { getColor, statLineSx, statLineTextSx } from './styles';

type Props = {
  count: number;
  text: string;
  color: 'warning' | 'error';
  onClick?: () => void;
  Icon: React.ElementType;
};

const StatLine: FC<Props> = ({ count, text, color, onClick, Icon }) => {
  return (
    <Box sx={statLineSx(color)}>
      <Icon sx={getColor(color, 'main')} size={20} />
      <Typography sx={statLineTextSx}>
        {count} {text}
      </Typography>
      {!!onClick && <Button onClick={onClick} size="small" variant="soft" color={color}>
        View
      </Button>}
    </Box>
  );
};

export default StatLine;
